export enum PaymentMethod {
    ItauBoleto = 1,
    ItauTransferencia = 2,
    ItauPix = 3
}



// WEBPACK FOOTER //
// ./src/app/shared/enums/PaymentMethod.ts